var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_icon_svg__clip0_343_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.713 14.44a1.158 1.158 0 00-.334 1.022l.933 5.179a1.14 1.14 0 01-.473 1.137 1.155 1.155 0 01-1.228.084l-4.65-2.432a1.183 1.183 0 00-.524-.138h-.285a.853.853 0 00-.284.095L6.22 21.829a1.224 1.224 0 01-.75.116 1.167 1.167 0 01-.934-1.339l.939-5.177a1.18 1.18 0 00-.334-1.03l-3.792-3.677a1.138 1.138 0 01-.282-1.203A1.182 1.182 0 012 8.729l5.218-.751a1.165 1.165 0 00.924-.641l2.297-4.726c.054-.106.125-.202.21-.285l.095-.073c.049-.054.106-.1.169-.137l.114-.042.175-.074h.45a1.172 1.172 0 01.924.632L14.9 7.337a1.17 1.17 0 00.871.64l5.218.752a1.188 1.188 0 01.953.79 1.145 1.145 0 01-.3 1.19l-3.929 3.732z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_icon_svg__clip0_343_95"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgStarIcon;